/*
    EmploymentPage
    採用ページの作成を行う
*/
import employmentPage from '../../api/employmentPage'

export default {
  namespaced: true,
  state: {
    contents: [],
    customContents: [],
    selectContent: {
      layout: 0,
      contents_id: null
    },
    pages: 1,
    cntCount: 0,
    cntCompanyCount: 0,
    rank: [],
    isContentsLoading: false,
    isSearch: false,
    isSaveContentsLoading: false,
    isImageLoading: false,
    isBulkCreate: false,
    isLoadingImport: false,
    contentsCompany: [],
    contentsPublic: [],
    contentsTops: [],
    contentsApply: [],
    companyList: [],
    parentContent: {},
    rootContents: [],
    temporaryContents: [],
    recommendContents: [],
    recommendContentsOther: [],
    allContensId: [],
    companyDisplayTags: [],
    companyManageTags: [],
  },
  actions: {
    // 静的な採用ページ作成に必要な情報をpostする
    postContents ({commit}, content) {
      commit('EP_CTS_POST', content)
    },
    postContentsRecruit ({commit}, {content, pages, layout}) {
      commit('EP_CTS_POST_REC', {content, pages, layout})
    },
    getContentsList ({commit}, {pages, isRecruitPage, userHash}) {
      commit('EP_CTS_GET', {pages, isRecruitPage, userHash})
    },
    getAllContentsId ({commit}) {
      commit('EP_ALL_CID_GET')
    },
    getContentsQuery ({commit}, {pages, isRecruitPage, query, userHash}) {
      commit('EP_CTS_GET_Q', {pages, isRecruitPage, query, userHash})
    },
    getContentsSort ({commit}, {pages, isRecruitPage, sortflg, idx, query, userHash}) {
      commit('EP_CTS_GET_S', {pages, isRecruitPage, sortflg, idx, query, userHash})
    },
    getContentsListPublic ({commit}, pages) {
      commit('EP_CTS_GET_PUB', pages)
    },
    getRecommendContents ({commit}, cid) {
      commit('EP_CTS_GET_RMD', cid)
    },
    putContents ({commit}, {content, pages}) {
      commit('EP_CTS_PUT', {content, pages})
    },
    syncCountContents ({commit}, company_id) {
      commit('EP_CTS_CNT', company_id)
    },
    addCustomContent ({commit}, content) {
      commit('EP_CTS_ADD_CUSTOM', content)
    },
    deleteCustomContent ({commit}, idx) {
      commit('EP_CTS_DEL_CUSTOM', idx)
    },
    setEditContent ({commit}, content) {
      commit('EP_CTS_SEL', content)
    },
    setEditContentCustom ({commit}, content) {
      commit('EP_CTS_SEL_CUSTOM', content)
    },
    postMainContentImage ({commit}, {contents_id, data, is_original}) {
      commit('EP_MCTS_IMG_POST', {contents_id, data, is_original})
    },
    postContentImage ({commit}, {contents_id, image_id, data, index, is_original}) {
      commit('EP_CTS_IMG_POST', {contents_id, image_id, data, index, is_original})
    },
    deleteContent ({commit}, content) {
      commit('EP_CTS_DELETE', content)
    },
    postContentImport ({commit}, contents) {
      commit('EP_CTS_IMP_POST', contents)
    },
    nextContentsTops ({commit}) {
      commit('EP_CTS_NEXT')
    },
    prevContentsTops ({commit}) {
      commit('EP_CTS_PREV')
    },
    getContentsSearch ({commit}, search) {
      commit('EP_CTS_SECH', search)
    },
    getContentsApply ({commit}) {
      commit('EP_CTS_APPLY')
    },
    getRootContent ({commit}) {
      commit('EP_RCTS_GET')
    },
    postRootContent ({commit}, {content, flg}) {
      commit('EP_RCTS_POST', {content, flg})
    },
    putRootContent ({commit}, {content, flg}) {
      commit('EP_RCTS_PUT', {content, flg})
    },
    deleteRootContent ({commit}, id) {
      commit('EP_RCTS_DEL', id)
    },
    excelImport ({commit}, data) {
      commit ('IS_LOADING_IMPORT_TRUE')
      return employmentPage.excelImport(data)
        .then(() => {
          commit('EP_IMPORT', data)
        })
        .catch((e) => {
          console.error(e)
          alert("エラーが発生いたしました。\n再読み込みいたします。")
          location.reload()
        })
    },
    excelExport ({commit}, data) {
      commit('EP_EXPORT', data)
    },
    excelExportAll ({commit}, {companyID, userHash}) {
      commit('EP_EXPORT_ALL', {companyID, userHash})
    },
    getAllContentsList () {
      return employmentPage.getAllContentsList()
        .then((d) => {
          return d.data
        })
    },
    // 求人原稿の変更履歴取得
    async getEmploymentChangeHistory({commit}, contentID){
      return await employmentPage.getEmploymentChangeHistory(contentID)
      .then((d) => {
        return JSON.parse(d.data)
      })
      .catch((e) => {
        alert('エラーが発生しました')
        return e
      })
    },
    // 求人原稿タグ取得
    getEmploymentPageTag({ commit }) {
      employmentPage.getEmploymentPageTag()
        .then((response) => {
          commit('EP_TAG_GET', response.data)
        })
        .catch((error) => {
          alert('求人原稿タグを取得できませんでした。お手数をお掛けいたしますが、リロードの実行をお願いいたします。')
        })
    },
    // 求人原稿タグ作成
    async createEmploymentPageTag({ commit }, createTagData) {
      await employmentPage.createEmploymentPageTag(createTagData)
        .then((response) => {
          commit('EP_TAG_CREATE', response.data)
          alert('タグの作成が完了しました。')
          return response
        })
        .catch((error) => {
          alert('タグを作成できませんでした。お手数をお掛けいたしますが、再度操作の実行をお願いいたします。')
        })
    },
    // 求人原稿タグ削除
    async deleteEmploymentPageTag({ commit }, tagID) {
      await employmentPage.deleteEmploymentPageTag(tagID)
        .then((response) => {
          commit('EP_TAG_DELETE',  { tagID: response.data.tag_id, isManage: response.data.is_manage })
          alert('タグの削除が完了しました。')
          return response
        })
        .catch((error) => {
          alert('タグを削除できませんでした。お手数をお掛けいたしますが、再度操作の実行をお願いいたします。')
        })
    },
  },
  mutations: {
    EP_CTS_SEL (state, content) {
      console.log('EP_CTS_SEL')
      var temp = null
      temp = content
      if (!temp.content['address']) {
        var data = {
          postalcode: '',
          region: '',
          locality: '',
          street: ''
        }
        temp.content['address'] = data
      }
      state.selectContent = temp
    },
    EP_CTS_SEL_CUSTOM (state, content) {
      console.log('EP_CTS_SEL_CUSTOM')
      state.selectContent = content
    },
    EP_ALL_CID_GET (state) {
      console.log('EP_ALL_CID_GET')
      employmentPage.getAllContentsId()
        .then((d) => {
          console.log('Success, getAllContentsId list is got')
          console.log(JSON.stringify(d.data))
          state.allContensId = d.data.allContensId
        })
        .catch((e) => {
          console.log('Failed, getAllContentsId list do not get\n' + e)
        })
    },
    EP_CTS_GET (state, {pages, isRecruitPage, userHash}) {
      console.log('EP_CTS_GET')
      state.isContentsLoading = true
      employmentPage.getContentsList(pages, isRecruitPage, userHash)
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          console.log(JSON.stringify(d.data))
          if (isRecruitPage) {
            state.contents = d.data.contents
            state.cntCount = d.data.count
            state.cntCompanyCount = d.data.company_count
          } else {
            state.contents = d.data.contents
            state.cntCount = d.data.count
            state.cntCompanyCount = d.data.company_count
          }
          setTimeout(() => state.isContentsLoading = false, 800)
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list do not get\n' + e)
          state.isContentsLoading = false
        })
    },
    EP_CTS_GET_Q (state, {pages, isRecruitPage, query, userHash}) {
      console.log('EP_CTS_GET_Q')
      state.isContentsLoading = true
      employmentPage.getContentsQuery(pages, isRecruitPage, query, userHash)
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          console.log(JSON.stringify(d.data))
          if (isRecruitPage) {
            state.contents = d.data.contents
            state.cntCount = d.data.count
            state.cntCompanyCount = d.data.company_count
          } else {
            state.contents = d.data.contents
            state.cntCount = d.data.count
            state.cntCompanyCount = d.data.company_count
          }
          setTimeout(() => state.isContentsLoading = false, 800)
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list do not get\n' + e)
          state.isContentsLoading = false
        })
    },
    EP_CTS_GET_S (state, {pages, isRecruitPage, sortflg, idx, query, userHash}) {
      console.log('EP_CTS_GET_S')
      state.isContentsLoading = true
      employmentPage.getContentsSort(pages, isRecruitPage, sortflg, idx, query, userHash)
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          console.log(JSON.stringify(d.data))
          if (isRecruitPage) {
            state.contents = d.data.contents
            state.cntCount = d.data.count
            state.cntCompanyCount = d.data.company_count
          } else {
            state.contents = d.data.contents
            state.cntCount = d.data.count
            state.cntCompanyCount = d.data.company_count
          }
          setTimeout(() => state.isContentsLoading = false, 800)
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list do not get\n' + e)
          state.isContentsLoading = false
        })
    },
    EP_CTS_GET_PUB (state, pages) {
      state.isContentsLoading = true
      employmentPage.getContentsListPublic(pages)
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          console.log(JSON.stringify(d.data))
          state.pages = pages
          state.contentsPublic = d.data.contents
          state.contentsTops = d.data.tops
          state.contentsCompany = d.data.company
          state.isContentsLoading = false
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list do not get\n' + e)
          state.isContentsLoading = false
        })
    },
    EP_CTS_GET_RMD (state, cid) {
      state.isContentsLoading = true
      employmentPage.getContentsRecommend(cid)
        .then((d) => {
          state.recommendContents = d.data.own
          state.recommendContentsOther = d.data.other
          state.isContentsLoading = false
        })
        .catch((e) => {
          state.isContentsLoading = false
        })
    },
    EP_CTS_SECH (state, search) {
      employmentPage.getContentsSearch(search)
        .then((d) => {
          console.log('Success, EP_CTS_IMP_POST')
          state.contentsPublic = d.data.contents
          state.isSearch = true
        })
        .catch((e) => {
          console.log('Failed, EP_CTS_IMP_POST' + e)
        })
    },
    EP_CTS_ADD_CUSTOM (state, content) {
      console.log('EP_CTS_ADD_CUSTOM')
      state.selectContent.content.list.push(content)
    },
    EP_CTS_DEL_CUSTOM (state, idx) {
      console.log('EP_CTS_DEL_CUSTOM')
      state.selectContent.content.list.splice(idx, 1)
    },
    EP_CTS_POST (state, content) {
      console.log('EP_PAGE_LIST_GET')
      employmentPage.postContents(content)
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          console.log(JSON.stringify(d.data))
          var temp = []
          for (var i in d.data) if (d.data[i].layout == 4) temp.push(d.data[i])
          state.contents = temp
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list do not get\n' + e)
        })
    },
    EP_CTS_POST_REC (state, {content, pages, layout}) {
      employmentPage.postContentsRecruit(content, pages, layout)
        .then((d) => {
          state.contents = d.data.contents
          state.cntCount = d.data.count
          state.cntCompanyCount = d.data.company_count
        })
        .catch((e) => {
          console.error(e)
        })
    },
    EP_CTS_PUT (state, {content, pages}) {
      console.log('EP_CTS_PUT')
      state.isSaveContentsLoading = true
      employmentPage.putContents(content, pages)
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          console.log(JSON.stringify(d.data))
          for (var idx in state.contents) {
            if (state.contents[idx].contents_id == content.contents_id) {
              console.log('*** CHECK SET ***' + idx)
              state.contents.splice(idx, 1, content)
            }
          }
          state.isSaveContentsLoading = false
        })
        .catch((e) => {
          state.isSaveContentsLoading = false
          console.log('Failed, EmploymentPage list do not get\n' + e)
        })
    },
    EP_CTS_CNT (state, company_id) {
      console.log('EP_CTS_CNT')
      employmentPage.syncCountContents(company_id)
        .then((d) => {
          console.log('Success')
        })
        .catch((e) => {
          console.log('Failed')
        })
    },
    EP_CTS_DELETE (state, content) {
      console.log('EP_CTS_DELETE')
      employmentPage.deleteContent(content)
        .then((d) => {
          console.log('Success, EmploymentPage list is deleted')
          for (var idx in state.contents) {
            if (state.contents[idx].contents_id == content.contents_id) {
              console.log('*** CHECK SET ***' + idx)
              state.contents.splice(idx, 1)
            }
          }
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list is not deleted' + e)
        })
    },
    EP_MCTS_IMG_POST (state, {contents_id, data, is_original}) {
      state.isImageLoading = true
      var postData = null
      if (is_original) {
        postData = {
          contents_id: contents_id,
          image_data: data.replace(/^.*,/, ''),
          is_original: true
        }
      } else {
        postData = {
          contents_id: contents_id,
          image_data: data,
          is_original: false
        }
      }
      employmentPage.postMainContentImage(postData)
        .then((d) => {
          console.log('SET_ICON_IMG API AFT: \n' + JSON.stringify(d))
          state.isImageLoading = false
          if (is_original) {
            state.selectContent.image = d.data.image
            state.selectContent.is_image_original = true
            state.selectContent.image_unsplash = false
            for (var i in state.contents) {
              if (state.contents[i].contents_id == contents_id) state.contents[i].image = d.data.image
            }
          } else {
            state.selectContent.image_unsplash = d.data.image
            state.selectContent.is_image_original = false
            state.selectContent.image_unsplash = true
            for (var i in state.contents) {
              if (state.contents[i].contents_id == contents_id) state.contents[i].image_unsplash = d.data.image
            }
          }
        })
        .catch((e) => {
          console.log('ERR SET_ICON_IMG API AFT: \n' + e)
        })
    },
    EP_CTS_IMG_POST (state, {contents_id, image_id, data, index, is_original}) {
      state.isImageLoading = true
      var postData = null
      if (is_original) {
        postData = {
          contents_id: contents_id,
          image_id: image_id,
          image_data: data.replace(/^.*,/, ''),
          is_original: true
        }
      } else {
        postData = {
          contents_id: contents_id,
          image_id: image_id,
          image_data: data,
          is_original: false
        }
      }
      employmentPage.postContentImage(postData)
        .then((d) => {
          console.log('SET_ICON_IMG API AFT: \n' + JSON.stringify(d))
          switch (state.selectContent.layout) {
            // 単数レイアウト
            case 0:
            case 2:
              state.selectContent.content.image.id = d.data.image_id
              state.selectContent.content.image.url = d.data.image_url
              break
            // 複数レイアウト
            case 1:
            case 3:
              state.selectContent.content.cards[index].image.id = d.data.image_id
              state.selectContent.content.cards[index].image.url = d.data.image_url
            default:
              break
          }
          state.isImageLoading = false
          // ついでに保存する
          this.putContents(state.selectContent)
        })
        .catch((e) => {
          console.log('ERR SET_ICON_IMG API AFT: \n' + e)
        })
    },
    EP_CTS_IMP_POST (state, contents) {
      console.log('EP_CTS_IMP_POST')
      state.isBulkCreate = true
      var data = []
      var tmpJson = { 
        layout_type   : 4,
        work_type     : '',
        tags          : [''],
        title         : '',
        sub_title     : '',
        work_title    : '',
        work_content  : '',
        wanted_person : '',
        work_time     : '',
        location      : '',
        selection_flow: '',
        salary        : '',
        holiday       : '',
        welfare       : '',
        image         : { id: '', url: '' },
        address       : { postalcode: '', region: '', locality: '', street: '' },
        google_map    : ''
      }
      for (var i in contents.dataList) {
        for (var j in contents.dataList[i]) {
          switch (Number(j)) {
            case 0:
              tmpJson['title'] = contents.dataList[i][j]
              break
            case 1:
              if (contents.dataList[i][j].indexOf('正社員') >= 0) tmpJson.work_type = 'FULL_TIME'
              else if (contents.dataList[i][j].indexOf('アルバイト') >= 0) tmpJson.work_type = 'PART_TIME'
              else if (contents.dataList[i][j].indexOf('契約社員') >= 0) tmpJson.work_type = 'CONTRACTOR'
              else if (contents.dataList[i][j].indexOf('インターン') >= 0) tmpJson.work_type = 'INTERN'
              else tmpJson['work_type'] = 'OTHER'
              break
            case 2:
              tmpJson['work_title'] = contents.dataList[i][j]
              break
            case 3:
              tmpJson['work_content'] = contents.dataList[i][j]
              break
            case 4:
              tmpJson['wanted_person'] = contents.dataList[i][j]
              break
            case 5:
              tmpJson['location'] = contents.dataList[i][j]
              break
            case 6:
              tmpJson['work_time'] = contents.dataList[i][j]
              break
            case 7:
              tmpJson['salary'] = contents.dataList[i][j]
              break
            case 8:
              tmpJson['holiday'] = contents.dataList[i][j]
              break
            case 9:
              tmpJson['welfare'] = contents.dataList[i][j]
              break
            case 10:
              tmpJson.selection_flow = contents.dataList[i][j]
              break
            case 11:
              tmpJson.address.postalcode = contents.dataList[i][j]
              break
            case 12:
              tmpJson.address.region = contents.dataList[i][j]
              break
            case 13:
              tmpJson.address.locality = contents.dataList[i][j]
              break
            case 14:
              tmpJson.address.street = contents.dataList[i][j]
              break
            default:
              break
          }
          // console.log(JSON.stringify(tmpJson))
        }
        tmpJson.google_map = tmpJson.address.region + tmpJson.address.locality + tmpJson.address.street
        data.push(tmpJson)
        tmpJson = { 
          layout_type   : 4,
          work_type     : '',
          tags          : [''],
          title         : '',
          sub_title     : '',
          work_title    : '',
          work_content  : '',
          wanted_person : '',
          work_time     : '',
          location      : '',
          selection_flow: '',
          salary        : '',
          holiday       : '',
          welfare       : '',
          image         : { id: '', url: '' },
          address       : { postalcode: '', region: '', locality: '', street: '' },
          google_map    : ''
        }
      }
      console.log(JSON.stringify(data))
      employmentPage.postContentImport(data)
        .then((d) => {
          console.log('Success, EP_CTS_IMP_POST')
          state.contents = d.data.contents
          state.cntCount = d.data.count
          state.isBulkCreate = false
        })
        .catch((e) => {
          console.log('Failed, EP_CTS_IMP_POST' + e)
        })
    },
    EP_CTS_NEXT (state) {
      state.contentsTops.splice(4, 0, state.contentsTops[0])
      state.contentsTops.splice(0, 1)
    },
    EP_CTS_PREV (state) {
      state.contentsTops.splice(0, 0, state.contentsTops[4])
      state.contentsTops.splice(5, 1)
    },
    EP_CTS_APPLY (state) {
      employmentPage.getContentsApply()
        .then((d) => {
          console.log('Success, EP_CTS_APPLY' + JSON.stringify(d.data.contents))
          state.contentsApply = d.data.contents
          state.companyList = d.data.company_list
        })
        .catch((e) => {
          console.log('Failed, EP_CTS_APPLY' + e)
        })
    },
    EP_RCTS_POST (state, {content, flg}) {
      console.log('EP_RCTS_POST')
      employmentPage.postRootContent(content)
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          state.temporaryContents = []
          if (flg) {
            for (const i in d.data) {
              if (d.data[i].salary == "") {
                state.temporaryContents.push(d.data[i])
              }
            }
          } else {
            state.rootContents = d.data
          }
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list do not get\n' + e)
        })
    },
    EP_RCTS_DEL (state, content) {
      console.log('EP_RCTS_DEL')
      employmentPage.deleteRootContent(content)
        .then((d) => {
          console.log('Success, EmploymentPage list is deleted')
          for (var idx in state.rootContents) {
            if (state.rootContents[idx].id == content.id) {
              console.log('*** CHECK SET ***' + idx)
              state.rootContents.splice(idx, 1)
            }
          }
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list is not deleted' + e)
        })
    },
    EP_RCTS_GET (state) {
      console.log('EP_RCTS_GET')
      employmentPage.getRootContent()
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          state.temporaryContents = []
          state.rootContents = d.data
          for (const i in state.rootContents) {
            if (state.rootContents[i].salary == "") {
              state.temporaryContents.push(state.rootContents[i])
            }
          }
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list do not get\n' + e)
        })
    },
    EP_RCTS_PUT (state, {content, flg}) {
      console.log('EP_RCTS_PUT')
      employmentPage.putRootContent(content)
        .then((d) => {
          console.log('Success, EmploymentPage list is got')
          state.temporaryContents = []
          state.rootContents = []
          if (flg) {
            state.temporaryContents.push(d.data)
          } else {
            state.rootContents.push(d.data)
          } 
        })
        .catch((e) => {
          console.log('Failed, EmploymentPage list do not get\n' + e)
        })
    },
    EP_IMPORT (state) {
      state.isLoadingImport = false
      alert("インポートが完了しました。\n再読み込みいたします。")
      location.reload()
    },
    EP_EXPORT (state, data) {
      employmentPage.excelExport(data)
    },
    EP_EXPORT_ALL (state, {companyID, userHash}) {
      employmentPage.excelExportAll(companyID, userHash)
    },
    IS_LOADING_IMPORT_TRUE (state) {
      state.isLoadingImport = true
    },
    // 求人原稿タグの取得
    EP_TAG_GET(state, { display_tags, manage_tags }) {
      state.companyDisplayTags = display_tags
      state.companyManageTags = manage_tags
    },
    // 求人原稿タグ作成
    EP_TAG_CREATE(state, tag){
      // 管理タグか表示タグかを判断してpushする
      if (tag.is_manage) {
        state.companyManageTags.push(tag)
      } else {
        state.companyDisplayTags.push(tag)
      }
    },
    // 求人原稿タグ削除
    EP_TAG_DELETE(state, { tagID, isManage }){
      // 管理タグか表示タグかを判断してpushする
      if (isManage) {
        state.companyManageTags = state.companyManageTags.filter(tag => tag.id !== tagID)
      } else {
        state.companyDisplayTags = state.companyDisplayTags.filter(tag => tag.id !== tagID)
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/employmentPage.js